import React from 'react';
import { withStyles } from '@material-ui/styles';
import { Grid, Avatar, Button, TextField } from '@material-ui/core';
import PropTypes from 'prop-types';

import FolderTwoToneIcon from '@material-ui/icons/FolderTwoTone';
import FeaturedVideoTwoToneIcon from '@material-ui/icons/FeaturedVideoTwoTone';
import PeopleAltTwoToneIcon from '@material-ui/icons/PeopleAltTwoTone';
import ChatTwoToneIcon from '@material-ui/icons/ChatTwoTone';
import EditTwoToneIcon from '@material-ui/icons/EditTwoTone';
import CloudUploadTwoToneIcon from '@material-ui/icons/CloudUploadTwoTone';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import '../../assets/scss/index.scss';

const styles = (theme => ({
  root: {
  }
}));

export class Dashboard extends React.PureComponent {
  constructor(...args) {
    super(...args);
    this._logoutTimerID = null;
    this._logoutIntervalID = null;

    const { user, league, payout } = this.props;
    this.state = {
      user,
      league,
      payout
    }
  }
  
  renderFolder = (name) => {
      return (
          <div>
              <FolderTwoToneIcon fontSize='small' color="primary"/><div style={{display: 'inline-block', verticalAlign: 'top', marginLeft: 8, paddingTop: 3}}>{name}</div>
          </div>
      )
  }

  renderAssetItem = (name) => {
    return (
        <div>
            <FeaturedVideoTwoToneIcon fontSize='small' color="default" style={{marginLeft: 4, fontSize: 12}}/><div style={{display: 'inline-block', verticalAlign: 'top', marginLeft: 8, paddingTop: 3}}>{name}</div>
        </div>
    )
    }

  renderRecentItem = (type, name, status) => {
      return (
          <div style={{ margin: '20px 0px' }}>
              {type === 'created' && (
                <FeaturedVideoTwoToneIcon fontSize='small' color="default" style={{ marginLeft: 4, fontSize: 16 }} />               
              )}
              {type === 'comments' && (
                <ChatTwoToneIcon fontSize='small' color="default" style={{ marginLeft: 4, fontSize: 16  }} />               
              )}
              {type === 'edit' && (
                <EditTwoToneIcon fontSize='small' color="default" style={{ marginLeft: 4, fontSize:16 }} />               
              )}
              {type === 'share' && (
                <PeopleAltTwoToneIcon fontSize='small' color="default" style={{ marginLeft: 4, fontSize: 16}} />               
              )}
              {type === 'upload' && (
                <CloudUploadTwoToneIcon fontSize='small' color="default" style={{ marginLeft: 4, fontSize: 16 }} />               
              )}
               <div style={{ display: 'inline-block', verticalAlign: 'top', marginLeft: 8, marginTop: -2 }}>
                  <a href="#" style={{color: '#5184f3'}}>{name}</a>
                  <div style={{ fontSize: 12, paddingLeft: 24, fontStyle: 'italic' }}>{status}
                  </div>
              </div>
          </div>
      )
  }

  renderLeftNav = () => {
    return (
        <div style={{ 
            position: 'fixed',
            zIndex: 1000, 
            background: '#303030',
            marginTop: 64,
            maxWidth: 200, padding: 14, fontSize: 12, borderRight: '1px solid #484747', minHeight: '100vh', fontWeight: 600}}
            >
            <div style={{marginTop: 18, marginBottom: 12, paddingBottom: 8, borderBottom: '1px solid #88888888'}}>
                <div className='menuTitle'>ActivMEDIA
                    <AddCircleOutlineIcon style={{float: 'right', fontSize: 20}} />
                </div>
                {this.renderFolder('Algebra')}
                {this.renderFolder('Social Studies')}
                {this.renderAssetItem('Welcome to Class')}
                {this.renderAssetItem('Homework Primer')}
            </div>
            <div style={{marginTop: 12, marginBottom: 12, paddingBottom: 8, borderBottom: '1px solid #88888888'}}>
            <div className='menuTitle'>Asset Library
               <AddCircleOutlineIcon style={{float: 'right', fontSize: 20}} />
            </div>
                {this.renderFolder('Videos')}
                {this.renderFolder('Images')}
                {this.renderFolder('Audio')}
                {this.renderFolder('Charts')}
                {this.renderFolder('Documents')}
                {this.renderFolder('Quotes')}
                {this.renderFolder('Links')}
                {this.renderFolder('Polls/Quizzes')}
            </div>
            <div style={{marginTop: 12, marginBottom: 12, paddingBottom: 8}}>
            <div className='menuTitle'>Play Lists
                <AddCircleOutlineIcon style={{float: 'right', fontSize: 20}} />
            </div>
                {this.renderFolder('3rd Period Algebra')}
                {this.renderFolder('Social Studies')}
            </div>
        </div>
    )
  }

  recentActivity = [
      {
          type: 'comments',
          name: 'Algebra > Lesson 2',
          status: '13 comments'
      },
      {
        type: 'edit',
        name: 'Welcome to Class',
        status: 'Edited 06.12.2020'
    },
    {
        type: 'upload',
        name: 'Algebra > Lesson 8',
        status: 'Uploaded 06.10.2020'
    },
    {
        type: 'share',
        name: 'Social Studies > Lesson 10',
        status: 'Shared with 12 people'
    },
    {
        type: 'comments',
        name: 'Social Studies > Lesson 9',
        status: '27 comments'
    },
        {
        type: 'created',
        name: 'Social Studies > Lesson 9',
        status: 'Created 05.08.2020'
    },
   
  ]
  renderRecentColumn = () => {

    return(
        <div>
             <h3>Recent ActivITY</h3>
             {this.recentActivity.map(activity => (
                 <>
                    {this.renderRecentItem(activity.type, activity.name, activity.status)}
                 </>
             ))

             }
        </div>
    )
  }

  render() {
    const { classes } = this.props;
    const { user,
      league,
      payout
    } = this.state;
    return (
    <div className={classes.root}>
       {this.renderLeftNav()}
       <div style={{/* width: 'calc(100% - 200px)', */ paddingLeft: 200, paddingTop: 90}}>
       <Grid container spacing={32} >
                    <Grid item xs={9} style={{paddingLeft: 32}}>
                        <h1>WELCOME</h1>
                        <div style={{ margin: 24 }}>
                            <h3>Create New ActivMEDIA</h3>
                            <div style={{ marginTop: 24, display: 'inline-block' }}>
                                <div style={{ display: 'inline-block' }}><Avatar className='avatar' >1</Avatar></div> Upload a Video
                            <div className='dropTarget'>
                                    Drop video here (.mp4)
                                <br /><br />
                                    <Button size='small' variant='outlined'>Select File</Button>
                                </div>
                                <div style={{margin: 27, textAlign: 'center'}}>
                            </div>
                            </div>
                            <div style={{ marginTop: 24, display: 'inline-block' }}>
                                <div style={{ display: 'inline-block' }}><Avatar className='avatar' >2</Avatar></div> Upload a Transcript (optional)
                            <div className='dropTarget'>
                                    Drop transcript here (.srt or .vtt)
                                <br /><br />
                                    <Button size='small' variant='outlined'>Select File</Button>
                                </div>
                            </div>
                            <div style={{ marginTop: 24 }}>
                                <div style={{ display: 'inline-block' }}><Avatar className='avatar' >3</Avatar></div> Name your ActivMEDIA
                            <form className={classes.root} noValidate autoComplete="off">
                                    <TextField 
                                        id="am-name" 
                                        label="Name" 
                                        variant="outlined"
                                        style={{ margin: 18, marginLeft: 32, width: 250 }} />
                                </form>
                            </div>
                            <div style={{margin: 27, textAlign: 'center'}}>
                                <Button size='large' variant='contained' color='primary'>Create ActivMedia</Button>
                            </div>
                        </div>
                    </Grid>
           <Grid item xs={3}>
               <div style={{borderLeft: '1px solid #484747', marginTop: 64, paddingLeft: 24, height: '100%'}}>
                {this.renderRecentColumn()}
               </div>
           </Grid>
       </Grid>
       </div>
    </div>
  );
    }
};

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object
};

export default withStyles(styles)(Dashboard);
